<template>
    <font-awesome-icon icon="info-circle" @click="toDetalhar()" size="lg" class="icon-button p-text-primary" title="Detalhar" />
</template>

<script>
export default {
    props: {
        participante: {
            type: Object,
        },
    },

    methods: {
        toDetalhar() {
            this.$router.push({
                name: 'Checkins_Eventos_Participantes_Detalhar',
                params: {
                    id: this.$route.params.id,
                    participanteId: this.participante.participanteId,
                },
            });
        },
    },
};
</script>
